import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MasterDataEditService } from '../../../../../api/master-data-edit.service';
import { AffectingBrandData } from '../../../../../shared/models/product.model';

@Component({
  selector: 'app-rename-brand',
  templateUrl: './rename-brand.component.html',
})
export class RenameBrandComponent implements OnInit {
  @ViewChild('existingBrandNameGrid') existingBrandNameGrid: DxDataGridComponent;

  public affectedEditBrandNameData: AffectingBrandData[] = [];
  public existingEditBrandNameData: AffectingBrandData[] = [];

  @Input() selectedEditBrandOldName: string;
  @Input() selectedEditBrandNewName: string;
  @Input() brandId;

  private _destroyed$ = new Subject();

  constructor(private masterDataEditService: MasterDataEditService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
	this.masterDataEditService.getAffectingBrandData(this.selectedEditBrandOldName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingBrandData[]) => {
		this.affectedEditBrandNameData = res;
		});

	this.masterDataEditService.getExistingBrandData(this.selectedEditBrandNewName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingBrandData[]) => {
		this.existingEditBrandNameData = res;
		});
  }

  rename() {
	this.activeModal.close('save');
  }

  customizeBrandId(cellInfo) {
	const idStr = 'BR_000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  valueChanged(event) {
	this.existingBrandNameGrid.instance.beginCustomLoading('Loading');
	this.masterDataEditService.getExistingBrandData(event.value)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingBrandData[]) => {
		this.existingEditBrandNameData = res;
		this.existingBrandNameGrid.instance.option('dataSource', res);
		this.existingBrandNameGrid.instance.endCustomLoading();
		});
  }

}
